export default ({
  allowed = [],
  role = 'anonymous',
  noAccess = null,
  children
}) => allowed.includes(role.toLowerCase()) ? children : noAccess;
